import React from "react";

/**
 * Marks an owner lead who wants to lease the property out rather than sell it
 * (Christian Gravias, DOMA 13375194285). Rental leads stay on Prospects and
 * Seller Leads but are left out of the sales analytics, so the card says why.
 * Renders nothing for a sale lead.
 */
const RentalLeadPill = ({ transactionType, className = "" }) =>
  transactionType === "rental" ? (
    <span
      title="Rental lead: not counted in the sales analytics"
      className={`px-1.5 sm:px-2 py-0.5 text-[9px] sm:text-[10px] rounded font-bold whitespace-nowrap bg-[#F3E8FF] text-[#7C3AED] ${className}`}
    >
      Rental
    </span>
  ) : null;

export default RentalLeadPill;
